import {createAction} from "redux-act";

interface IButton {
	onClick?: () => void;
	text: string;
}

interface IShowPromptModal {
	confirmButton: IButton;
	denyButton: IButton;
	closeButton?: Exclude<IButton, "text">;
	title: string;
	description: string;
}

export const showPromptModal = createAction<IShowPromptModal>();
export const closePromptModal = createAction();
